import { GridToolbarQuickFilter, GridToolbarExport } from '@mui/x-data-grid';
import { Box } from '@mui/material';

export function QuickSearchToolbar() {
    return (
      <>
        <Box sx={{ p: 0.5, pb: 0, float: 'left' }}>
          <GridToolbarExport printOptions={{ disableToolbarButton: true }}/>
        </Box>
        <Box sx={{ p: 0.5, pb: 0, float: 'right' }}>
          <GridToolbarQuickFilter />
        </Box>
      </>
    );
  }